import { FiscalType } from '../../enums/fiscalTypeEnum'

export const getFiscalShortName = (
  fiscalType: string,
  countryRegistration: string
) => {
  const ft = Number(fiscalType)
  return {
    label: {
      eng: ft === FiscalType.IP
        ? 'Abbreviated name IP*'
        : 'Short company name*',
      rus: ft === FiscalType.IP
        ? 'Сокращенное наименование ИП*'
        : 'Краткое название компании*',
      kz: ft === FiscalType.IP
        ? 'Қысқартылған атау IP*'
        : ft === FiscalType.JSC
        ? 'Қысқартылған атау АҚ*'
        : ft === FiscalType.PJSC || ft === FiscalType.CJSC
        ? 'Қысқартылған атау ЖАҚ*'
        : ft === FiscalType.LLP
        ? 'Қысқартылған атау ЖШС*'
        : 'Қысқартылған атау ЖШС*',
    },
    placeholder: {
      eng: ft === FiscalType.IP
        ? countryRegistration === '398' ? 'IP «Lastochka»' : 'IP «MPK»'
        : ft === FiscalType.JSC
        ? countryRegistration === '398' ? 'JSC «APK»' : 'JSC «MPK»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '398' ? 'PJSC «APK»' : 'PJSC «MPK»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '398' ? 'CJSC «APK»' : 'CJSC «MPK»'
        : ft === FiscalType.LLP
        ? countryRegistration === '398' ? 'LLP «APK»' : 'LLP «MPK»'
        : 'LLC «MPK»',
      rus: ft === FiscalType.IP
        ? countryRegistration === '398' ? 'ИП «Ласточка»' : 'ИП «MПK»'
        : ft === FiscalType.JSC
        ? countryRegistration === '398' ? 'АО «АПK»' : 'АО «MПK»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '398' ? 'ПАО «АПK»' : 'ПАО «MПK»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '398' ? 'ЗАО «АПK»' : 'ЗАО «MПK»»'
        : ft === FiscalType.LLP && countryRegistration === '398'
        ? 'ТОО «АПK»'
        : 'ООО «MПK»',
      kz: ft === FiscalType.IP
        ? countryRegistration === '398' ? 'IP «Martïn»' : 'IP «MPK»'
        : ft === FiscalType.JSC
        ? countryRegistration === '398' ? 'АҚ «APK»' : 'АҚ «MPK»'
        : ft === FiscalType.PJSC
        ? countryRegistration === '398' ? 'ЖАҚ «APK»' : 'ЖАҚ «MPK»'
        : ft === FiscalType.CJSC
        ? countryRegistration === '398' ? 'ЖАҚ «APK»' : 'ЖАҚ «MPK»'
        : ft === FiscalType.LLP
        ? countryRegistration === '398' ? 'ЖШС «APK»' : 'ЖШС «MPK»'
        : 'ЖШС «MPK»',
    },
    invalidText: {
      eng: 'Enter the name of the LLP correctly ',
      rus: 'Введите наименование ТОО корректно',
      kz: 'ЖШС атауын дұрыс енгізіңіз',
    },
  }
}
